import {
  Display1,
  Display2,
  Display3,
  Editorial,
  H1,
  H1Semibold,
  H2,
  H3,
  H4,
  H5,
  H5Semibold,
  H6,
  H6Semibold,
  QuoteLarge,
  QuoteSmall,
  QuoteLargeWhite,
  QuoteSmallWhite,
} from './styles';
import type { IHeadlineProps } from './types';

const headlineVariants = {
  display1: Display1,
  display2: Display2,
  display3: Display3,
  editorial: Editorial,
  div: H2,
  h1: H1,
  h1Semibold: H1Semibold,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h5Semibold: H5Semibold,
  h6: H6,
  h6Semibold: H6Semibold,
  quoteLarge: QuoteLarge,
  quoteSmall: QuoteSmall,
  quoteLargeWhite: QuoteLargeWhite,
  quoteSmallWhite: QuoteSmallWhite,
};

const Headline = ({
  content, setInnerHTML = false, styledAs = '', tag = 'h2', ...props
}: IHeadlineProps) => {
  const args = {
    as: tag,
    styledAs: styledAs || tag,
    ...props,
  };
  const StyledHeadline = headlineVariants[args.styledAs];
  if (setInnerHTML) {
    args.dangerouslySetInnerHTML = { __html: content };
  } else {
    args.children = content;
  }

  return <StyledHeadline {...args} />;
};

export default Headline;
